export const DEFAULT_CALLBACKS = {
  onStart: () => {},
  onPreviousStep: (currentStep) => {},
  onNextStep: (currentStep) => {},
  onStop: () => {}
}

// ## VTour options
export const DEFAULT_OPTIONS = {
  useKeyboardNavigation: false,
  startTimeout: 1000,
  skipable: true,
  activeClass: 'v-step--active',
  labels: {
    buttonSkip: 'Überspringen',
    buttonPrevious: 'Zurück',
    buttonNext: 'Nächster',
    buttonStop: 'Beenden'
  }
}

// ## Popper options
export const DEFAULT_STEP_OPTIONS = {
  placement: 'auto',
  enableScrolling: false,
  positionFixed: true,
  modifiers: [
    {name: 'arrow', options: {element: '.v-step__arrow'}}
  ]
}

export const KEYS = {
  ARROW_RIGHT: 'ArrowRight',
  ARROW_LEFT: 'ArrowLeft',
  ESCAPE: 'Escape'
}
